export enum ToastVariant {
    ERROR = 'error',
    SUCCESS = 'success',
    WARNING = 'warning',
}
